module.exports = __webpack_public_path__ + "img/睦邻分中心1.fb7afe49.jpg";